/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAssignmentUser } from './InternalApiAssignmentUser';
import {
    InternalApiAssignmentUserFromJSON,
    InternalApiAssignmentUserFromJSONTyped,
    InternalApiAssignmentUserToJSON,
    InternalApiAssignmentUserToJSONTyped,
} from './InternalApiAssignmentUser';

/**
 * 
 * @export
 * @interface InternalApiSnoozeConfig
 */
export interface InternalApiSnoozeConfig {
    /**
     * 
     * @type {number}
     * @memberof InternalApiSnoozeConfig
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiSnoozeConfig
     */
    personId?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiSnoozeConfig
     */
    scenarioHandle?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiSnoozeConfig
     */
    scenarioReason?: string;
    /**
     * 
     * @type {InternalApiAssignmentUser}
     * @memberof InternalApiSnoozeConfig
     */
    createdBy: InternalApiAssignmentUser;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiSnoozeConfig
     */
    createdTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiSnoozeConfig
     */
    endTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof InternalApiSnoozeConfig
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiSnoozeConfig
     */
    totalAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiSnoozeConfig
     */
    note: string;
}

/**
 * Check if a given object implements the InternalApiSnoozeConfig interface.
 */
export function instanceOfInternalApiSnoozeConfig(value: object): value is InternalApiSnoozeConfig {
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function InternalApiSnoozeConfigFromJSON(json: any): InternalApiSnoozeConfig {
    return InternalApiSnoozeConfigFromJSONTyped(json, false);
}

export function InternalApiSnoozeConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSnoozeConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'personId': json['personId'] == null ? undefined : json['personId'],
        'scenarioHandle': json['scenarioHandle'] == null ? undefined : json['scenarioHandle'],
        'scenarioReason': json['scenarioReason'] == null ? undefined : json['scenarioReason'],
        'createdBy': InternalApiAssignmentUserFromJSON(json['createdBy']),
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'amount': json['amount'] == null ? undefined : json['amount'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'note': json['note'],
    };
}

export function InternalApiSnoozeConfigToJSON(json: any): InternalApiSnoozeConfig {
    return InternalApiSnoozeConfigToJSONTyped(json, false);
}

export function InternalApiSnoozeConfigToJSONTyped(value?: InternalApiSnoozeConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personId': value['personId'],
        'scenarioHandle': value['scenarioHandle'],
        'scenarioReason': value['scenarioReason'],
        'createdBy': InternalApiAssignmentUserToJSON(value['createdBy']),
        'createdTime': value['createdTime'] == null ? value['createdTime'] : value['createdTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
        'amount': value['amount'],
        'totalAmount': value['totalAmount'],
        'note': value['note'],
    };
}

